module.exports = __webpack_public_path__ + "img/loader.7716842a.gif";